var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import TechStack from './TechStack';
import { uuidv4 } from '../../../common/utils';
/**
 * You can freely show off the skills or abilities by using TechStackList component.
 *
 * @props id: Name to be added to Sidebar.
 * @props techStackList: Enter the properties such as nameOption, progressBarOption and click the {@link https://github.com/modern-agile-team/dev-portfolio#techstacklist link} if you want to see the README.md about TechStackList.
 * @props gap: Spacing between technical-stack elements in TechStackList. (default: 'normal') 'narrower' | 'narrow' | 'normal' | 'wide' | 'wider'
 */
var TechStackList = function (_a) {
    var id = _a.id, techStackList = _a.techStackList, gap = _a.gap;
    return (_jsx("div", __assign({ id: id }, { children: techStackList === null || techStackList === void 0 ? void 0 : techStackList.map(function (_a) {
            var nameOption = _a.nameOption, progressBarOption = _a.progressBarOption;
            return (_jsx(TechStack, { nameOption: nameOption, progressBarOption: progressBarOption, gap: gap }, uuidv4()));
        }) })));
};
export default TechStackList;
TechStackList.defaultProps = {
    techStackList: [
        {
            nameOption: {
                name: 'Javascript',
                nameTextColor: 'black',
                logoName: 'Javascript',
                fontSize: '18px',
                logoSize: '24px',
            },
            progressBarOption: {
                rateText: '45%',
                rateTextColor: 'black',
                isHiddenRateText: false,
                backgroundColor: 'black',
                colorTo: '#E2D784',
                colorFrom: 'whitesmoke',
                width: '100%',
                height: '40px',
                animationType: 'fill-up-wave',
                isBlinking: true,
            },
        },
        {
            nameOption: { name: 'HTML5', nameTextColor: 'black', logoName: 'HTML-5', fontSize: '18px', logoSize: '24px' },
            progressBarOption: {
                rateText: '30%',
                rateTextColor: 'black',
                isHiddenRateText: false,
                backgroundColor: 'black',
                colorTo: '#E34F26',
                colorFrom: 'whitesmoke',
                width: '100%',
                height: '40px',
                animationType: 'fill-up-wave',
                isBlinking: true,
            },
        },
        {
            nameOption: { name: 'Nodejs', nameTextColor: 'black', logoName: 'Nodejs', fontSize: '18px', logoSize: '24px' },
            progressBarOption: {
                rateText: '85%',
                rateTextColor: 'black',
                isHiddenRateText: false,
                backgroundColor: 'black',
                colorTo: '#339933',
                colorFrom: 'whitesmoke',
                width: '100%',
                height: '40px',
                animationType: 'fill-up-wave',
                isBlinking: true,
            },
        },
    ],
    gap: 'normal',
};
